import IZone from "interfaces/IZone";

export interface ICleaningObjectStoreState {
  cleaningObjects?: IZone[];
}

export const initialCleaningObjectStoreState: ICleaningObjectStoreState = {};
